// extracted by mini-css-extract-plugin
module.exports = {"BurgerControls":"BurgerControls_BurgerControls__3aUbm","OrderButton":"BurgerControls_OrderButton__2baXe","enable":"BurgerControls_enable__zxX90"};